export const UPDATE_BRIDGE = 'bridge/UPDATE';

export const CREATE_OPERATOR_BRIDGE = 'bridge/CREATE_OPERATOR_BRIDGE';
export const CREATE_ROOMS_BRIDGE = 'bridge/CREATE_ROOMS_BRIDGE';
export const CREATE_VISITOR_MONITORING_BRIDGE = 'bridge/CREATE_VISITOR_MONITORING_BRIDGE';

export const REQUIRE_NET_JS = 'bridge/REQUIRE_NET_JS';
export const TRY_CONNECT_TO_NET_JS = 'bridge/TRY_CONNECT_TO_NET_JS';
export const TRY_LOGIN_TO_NET_JS = 'bridge/TRY_LOGIN_TO_NET_JS';

export const CONNECTED_TO_NET_JS = 'bridge/CONNECTED_TO_NET_JS';

export const createOperatorBridge = () => ({
  type: CREATE_OPERATOR_BRIDGE,
});

export const createRoomsBridge = () => ({
  type: CREATE_ROOMS_BRIDGE,
});

export const createVisitorMonitoringBridge = () => ({
  type: CREATE_VISITOR_MONITORING_BRIDGE,
});

export const requireNetJs = () => ({
  type: REQUIRE_NET_JS,
});

export const connectToNetJs = () => ({
  type: TRY_CONNECT_TO_NET_JS,
});

export const tryLoginToNetJs = () => ({
  type: TRY_LOGIN_TO_NET_JS,
});

export const connectedToNetJs = sessionData => ({
  type: CONNECTED_TO_NET_JS,
  payload: sessionData,
});
